import { Query } from '@/_core/cqrs/types/queries';

export interface McpConsentItem {
    AuthorizationId: string;
    ClientId: string;
    ClientName: string;
    Scopes: string[];
    CreatedAt: string | null;
    WorkspaceId: number | null;
    WorkspaceName: string | null;
}

export interface GetMcpConsentsResult {
    Consents: McpConsentItem[];
    HasError: boolean;
    ErrorMessage: string | null;
}

export class GetMcpConsentsQuery extends Query<GetMcpConsentsResult> {
    constructor() {
        super('GetMcpConsents');
    }
}
